import { HttpInterceptorFn } from '@angular/common/http';

export const authErrorInterceptor: HttpInterceptorFn = (request, next) => {
  return next(request);
};
